export function getMaxRefereeProductTypeDiscount(product_type_discount: any): number | null {
  if (!product_type_discount) {
    console.warn('Could not display Referee Amount via getMaxRefereeProductTypeDiscount()')
    return null
  }

  return (Object.keys(product_type_discount))
    .map((product_type_name: string) => {
      const productSpecificDiscount = product_type_discount[product_type_name]
      return productSpecificDiscount.value_new_user
    }).reduce((a, b) => Math.max(a, b))
}
